const mn = {
  agency: "Цагдаагийн Ерөнхий Газар",
  agencySub: "МОНГОЛ УЛС",
  system: "Мансууруулах бодисын гэмт хэргийн мөрдөн шалгах нэгдсэн платформ",
  searchPlaceholder: "Хэргийн дугаар, холбогдогч, эд мөрийн баримт хайх",
  userName: "Мөрдөгч Б.Ганзориг",
  userOrg: "Мансууруулах бодистой тэмцэх газар, 2-р хэлтэс",
  notif: "Мэдэгдэл",
  logout: "Гарах",
  dashTitle: "Мөрдөн шалгалтын хяналтын самбар",
  dashSub: "Мансууруулах бодистой тэмцэх газар — 2026 оны эхний хагас жил",
  kpiActiveCases: "Идэвхтэй хэрэг",
  kpiArrests: "Баривчилсан хүн",
  kpiSeizure: "Хураасан нийт хэмжээ",
  kpiPending: "Шинжилгээ хүлээж буй",
  kpiVsPrev: "Өмнөх улиралтай харьцуулахад",
  trendTitle: "Сар бүрийн хэрэг бүртгэл, баривчилгааны хандлага",
  trendCases: "Бүртгэсэн",
  trendArrests: "Баривчилсан",
  byTypeTitle: "Мансууруулах бодисын төрлөөр хураасан хэмжээ",
  byTypeUnit: "(г-аар)",
  statusTitle: "Хэргийн шийдвэрлэлтийн төлөв",
  statusOngoing: "Мөрдөгдөж буй",
  statusProsecuted: "Шилжүүлсэн",
  statusClosed: "Хаасан",
  regionTitle: "Бүс нутгаар гарсан тархалт",
  recentTitle: "Сүүлд бүртгэсэн хэрэг",
  quickActions: "Шуурхай үйлдэл",
  qaNewCase: "Хэрэг бүртгэх",
  qaNewEvidence: "Эд мөрийн баримт бүртгэх",
  qaRequest: "Шинжилгээний хүсэлт",
  qaReport: "Тайлан бичих",
  alertsTitle: "Анхаарах шаардлагатай",
  cases: "хэрэг",
  persons: "хүн",
  thisMonth: "Энэ сар",
  viewCase: "Хэрэг харах",
  mDashboard: "Хяналтын самбар",
  geoTitle: "Газарзүйн шинжилгээ",
  geoSub: "Улаанбаатар хотын дүүрэг бүрээр мансууруулах бодисын гэмт хэргийн тархалт",
  viewMarkers: "Цэгийн тэмдэглэгээ",
  viewHeatmap: "Дулааны зураг",
  geoFilterSubstance: "Бодисын төрөл",
  hotspotRank: "Халуун цэгийн жагсаалт",
  incidents: "Гарсан тоо",
  topSubstance: "Гол бодис",
  selectedRegion: "Сонгосон бүс",
  regionIncidents: "Нийт гарсан",
  regionActive: "Идэвхтэй хэрэг",
  regionArrest: "Баривчилсан",
  legendDensity: "Гарсан нягтрал",
  densityLow: "Бага",
  densityHigh: "Их",
  routeTitle: "Гол нэвтрэх зам",
  routeSub: "Хил → нийслэл нэвтрсэн таамагласан зам",
  geoUpdated: "Сүүлийн 90 хоног",
  clickRegionHint: "Дүүргийн дээр дарж дэлгэрэнгүй статистик харна уу",
  frTitle: "Форензик хүсэлт",
  frSub: "Мансууруулах бодис, дижитал, био зэрэг шинжилгээний хүсэлт",
  frNo: "Хүсэлтийн дугаар",
  frDevice: "Төхөөрөмж",
  frTarget: "Шинжилгээний зүйл",
  frField: "Шинжилгээний чиглэл",
  frResults: "Шинжилгээний үр дүн",
  catDrugF: "Мансууруулах бодис",
  catDigitalF: "Дижитал",
  catDnaF: "Био/DNA",
  catPrintF: "Хурууны хээ",
  catDocF: "Баримт·бичгийн хэв",
  catToxF: "Хорт бодис",
  ftDrugQual: "Мансууруулах бодис илрүүлэх",
  ftDrugQuant: "Мансууруулах бодис хэмжих",
  ftUnknown: "Тодорхойгүй бодис",
  ftDna: "DNA шинжилгээ",
  ftFingerprint: "Хурууны хээ",
  ftTox: "Хорт бодис шинжилгээ",
  ftDoc: "Баримт·бичгийн хэв",
  frType: "Шинжилгээний төрөл",
  frRequester: "Хүсэгч",
  frAnalyst: "Шинжээч",
  frPriority: "Тэргүүлэл",
  frDate: "Хүсэлт гаргасан",
  frProgress: "Шинжилгээний явц",
  frArtifacts: "Гаргаж авсан өгөгдөл",
  frStepsTitle: "Шинжилгээний явцын түүх",
  newRequest: "Хүсэлт үүсгэх",
  ftExtract: "Өгөгдөл гаргах",
  ftCalls: "Дуудлагын түүх",
  ftMessages: "Зурвас сэргээх",
  ftLocation: "Байршлын түүх",
  ftRecovery: "Устгасан файл сэргээх",
  fsReceived: "Хүлээн авсан",
  fsAnalyzing: "Шинжилж буй",
  fsDone: "Дууссан",
  fsHold: "Тҭтгэлзсэн",
  priHigh: "Яаралтай",
  priNormal: "Енгийн",
  frTotal: "Нийт хүсэлт",
  frAnalyzingC: "Шинжилж буй",
  frDoneC: "Дууссан",
  frHoldC: "Тҭтгэлзсэн",
  rpTitle: "Шинжилгээний тайлан",
  rpSub: "Дижитал форензик шинжилгээний үр дүн",
  rpNo: "Тайлангийн дугаар",
  rpAuthor: "Бичсэн",
  rpDate: "Огноо",
  rpSecurity: "Нууцлал",
  rpTool: "Шинжилгээний хэрэгсэл",
  rpOverview: "Шинжилгээний тойм",
  rpFindings: "Гол илрүүлэлт",
  rpExtracted: "Гаргаж авсан өгөгдлийн хураангуй",
  rpCommFreq: "Харилцааны давтамж",
  rpConclusion: "Дүгнэлт",
  rpContact: "Харилцсан",
  rpTimes: "удаа",
  rpApproved: "Батлагдсан",
  rpReview: "Хянаж буй",
  rpDraft: "Ноорог",
  sevHigh: "Чухал",
  sevMid: "Анхаар",
  sevInfo: "Лавлах",
  downloadPdf: "PDF татах",
  reportList: "Тайлангийн жагсаалт",
  mAudit: "Аудитын бүртгэл",
  rolesTitle: "Дүрэм, эрхийн удирдлага",
  rolesSub: "Хэрэглэгчийн дүрмээр функцэд нэвтрэх эрх",
  addRole: "Дүрэм нэмэх",
  roleMembers: "Гишүүд",
  permMatrix: "Функц бүрээр эрх",
  permModule: "Цэс / функц",
  permView: "Үзэх",
  permCreate: "Үүсгэх",
  permEdit: "Засах",
  permDelete: "Устгах",
  permApprove: "Батлах",
  permExport: "Татах",
  modCase: "Хэргийн удирдлага",
  modEvidence: "Эд мөрийн баримт",
  modDrug: "Бодисын өгөгдөл",
  modAnalysis: "Шинжилгээ",
  modForensic: "Форензик",
  modStats: "Статистик / Тайлан",
  modSystem: "Системийн удирдлага",
  grantedCount: "Олгосон эрх",
  auditTitle: "Аудитын бүртгэл",
  auditSub: "Системийн хэрэглэгчийн үйл ажиллагааны бүртгэл",
  colTime: "Огноо, цаг",
  colUser: "Хэрэглэгч",
  colAction: "Үйлдэл",
  colTarget: "Байгуулла",
  colModule: "Цэс",
  colIp: "IP хаяг",
  colResult: "Үр дүн",
  actLogin: "Нэвтэрсэн",
  actLogout: "Гарсан",
  actView: "Үзсэн",
  actCreate: "Үүсгэсэн",
  actEdit: "Зассан",
  actDelete: "Устгасан",
  actExport: "Татсан",
  actPerm: "Эрх өөрчлөсөн",
  resOk: "Амжилттай",
  resFail: "Амжилтгүй",
  resDenied: "Эрхгүй",
  filterUser: "Хэрэглэгч",
  filterAction: "Үйлдэл",
  filterResult: "Үр дүн",
  auditTotal: "Нийт бүртгэл",
  auditToday: "Өнөөдөр",
  auditDenied: "Эрх татгалзсан",
  auditFail: "Амжилтгүй",
  mInvest: "Мөрдөн шалгалт",
  mDrugData: "Бодисын өгөгдөл",
  mAnalysis: "Шинжилгээ",
  mForensic: "Форензик",
  mAgency: "Байгууллагын холбоо",
  mStats: "Статистик / Тайлан",
  mSupport: "Ажлын дэмжлэг",
  mSystem: "Системийн удирдлага",
  mMyInfo: "Миний мэдээлэл",
  mCase: "Хэргийн удирдлага",
  mSubject: "Холбогдогчийн удирдлага",
  mEvidence: "Эд мөрийн баримт",
  mRequest: "Хүсэлтийн удирдлага",
  mSubstance: "Бодисын мэдээллийн сан",
  mSpectrum: "Спектрийн лавлагаа",
  mFieldData: "Хээрийн шинжилгээний өгөгдөл",
  mDataset: "Сургалтын өгөгдлийн багц",
  mModel: "Загварын удирдлага",
  mRelation: "Сүлжээний шинжилгээ",
  mGeo: "Газарзүйн шинжилгээ",
  mStatAnalysis: "Статистик шинжилгээ",
  mForensicReq: "Форензик хүсэлт",
  mDigitalEvidence: "Дижитал эд мөрийн баримт",
  mReport: "Шинжилгээний тайлан",
  mOtherAgency: "Бусад байгууллагын мэдээлэл",
  mMigration: "Хуучин өгөгдөл шилжүүлэх",
  mInvStats: "Мөрдөн шалгалтын статистик",
  mReports: "Тайлан",
  home: "Нүүр",
  list: "Жагсаалт",
  detail: "Дэлгэрэнгүй",
  search: "Хайх",
  reset: "Цэвэрлэх",
  register: "Бүртгэх",
  edit: "Засах",
  print: "Хэвлэх",
  excel: "Excel татах",
  save: "Хадгалах",
  approve: "Батлуулах хүсэлт",
  total: "Нийт",
  items: "бичлэг",
  viewAll: "Бүгдийг харах",
  select: "Сонгох",
  actions: "Үйлдэл",
  period: "Хугацаа",
  status: "Төлөв",
  type: "Төрөл",
  all: "Бүгд",
  name: "Нэр",
  page: "Хуудас",
  lastUpdated: "Сүүлд зассан",
  demoNote: "Энэ дэлгэц нь танилцуулгын демо бөгөөд бүх өгөгдөл зохиомол болно",
  caseDetailTitle: "Хэргийн дэлгэрэнгүй",
  caseNo: "Хэргийн дугаар",
  caseName: "Хэргийн нэр",
  caseStatusActive: "Мөрдөгдөж буй",
  tabBasic: "Үндсэн мэдээлэл",
  tabDrugCard: "Бодисын карт",
  tabPersons: "Холбогдох хүмүүс",
  tabEvidence: "Эд мөрийн баримт",
  caseType: "Хэргийн төрөл",
  caseTypeVal: "Мансууруулах бодис худалдаалах, түгээх",
  receivedDate: "Бүртгэсэн огноо",
  occurredDate: "Үйлдэгдсэн огноо",
  occurredPlace: "Үйлдэгдсэн газар",
  jurisdiction: "Харьяалал",
  assignedTeam: "Хариуцсан нэгж",
  leadInvestigator: "Ахлах мөрдөгч",
  coInvestigators: "Хамтран мөрдөгч",
  overview: "Хэргийн товч агуулга",
  caseOverviewText: "Улаанбаатар хотын Баянзүрх дүүргийн нутаг дэвсгэрт нууц чатын сувгаар метамфетамин худалдаалсан зохион байгуулалттай хэрэг. Хилээр нэвтрүүлсэн замыг мөрдөж байгаа бөгөөд хамтран гүйцэтгэгч 2 хүнд нэмэлт мөрдөн шалгалт явагдаж байна.",
  progressHistory: "Явцын түүх",
  relatedRequests: "Холбогдох хүсэлт",
  intlCoop: "Олон улсын хамтын ажиллагаа",
  intlCoopVal: "UNODC мэдээлэл солилцох хүсэлт (явагдаж буй)",
  securityLevel: "Нууцлалын зэрэглэл",
  securityLevelVal: "2-р зэрэг — Зөвхөн мөрдөн шалгах баг",
  h1: "Хэрэг бүртгэж, мөрдөн шалгалт эхэлсэн",
  h2: "Нэгжлэг хийж 12 эд мөрийн баримт хураасан",
  h3: "Сэжигтэн 1 хүнийг яаралтай баривчилсан",
  h4: "Шинжилгээний хүсэлт — Шүүхийн шинжилгээний үндэсний хүрээлэн",
  h5: "Сүлжээний шинжилгээний тайлан бүртгэсэн",
  drugCardTitle: "Бодисын карт",
  drugCardNo: "Картын дугаар",
  substanceName: "Бодисын нэр",
  seizedAmount: "Хураасан хэмжээ",
  purity: "Цэвэршилт",
  form: "Хэлбэр",
  formVal: "Талст хэлбэртэй (кристал)",
  packaging: "Сав баглаа",
  packagingVal: "Жижиг гялгар уут 24 ширхэг",
  seizureDate: "Хураасан огноо",
  seizurePlace: "Хураасан газар",
  analysisStatus: "Шинжилгээний төлөв",
  analysisDone: "Шинжилгээ дууссан",
  analysisPending: "Шинжилгээ хүлээгдэж буй",
  inboundRoute: "Нэвтэрсэн зам (таамаг)",
  inboundRouteVal: "Замын-Үүд хил → Улаанбаатар (авто зам)",
  streetValue: "Зах зээлийн үнэлгээ",
  distributionMethod: "Түгээх арга",
  distributionMethodVal: "Нууц чат суваг — нуусан газраас авах арга",
  relatedSubstances: "Холбоотой бодисын карт",
  cardCreated: "Карт үүсгэсэн огноо",
  personRole: "Үүрэг",
  personDob: "Төрсөн он",
  personAddress: "Хаяг",
  personPhone: "Утас",
  personStatus: "Цагдан хорих байдал",
  roleSuspect: "Сэжигтэн",
  roleAccomplice: "Хамтрагч",
  roleVictim: "Хохирогч",
  roleWitness: "Гэрч",
  custodyArrested: "Цагдан хоригдсон",
  custodyWanted: "Эрэн сурвалжлагдаж буй",
  custodyReleased: "Хорихгүй мөрдөгдөж буй",
  custodyInvestigating: "Шалгагдаж буй",
  priorRecord: "Урьд ял",
  priorYes: "Мансууруулах бодисын ял 1 удаа",
  priorNo: "Байхгүй",
  viewRelationMap: "Сүлжээний зураг харах",
  evidenceNo: "Баримтын дугаар",
  evidenceName: "Зүйлийн нэр",
  evidenceCategory: "Ангилал",
  storageLocation: "Хадгалах байршил",
  storageStatus: "Хадгалалтын төлөв",
  chainOfCustody: "Шилжилт хөдөлгөөний түүх",
  catDrug: "Мансууруулах бодис",
  catDigital: "Дижитал төхөөрөмж",
  catCash: "Бэлэн мөнгө / үнэт зүйл",
  catOther: "Бусад",
  stInStorage: "Хадгалагдаж буй",
  stAnalysis: "Шинжилгээнд",
  stDisposalReq: "Устгах хүсэлттэй",
  stTransferred: "Шилжүүлсэн",
  registerEvidence: "Эд мөрийн баримт бүртгэх",
  requestDisposal: "Шийдвэрлэх хүсэлт",
  evidenceListTitle: "Эд мөрийн баримтын удирдлага",
  summaryTotal: "Нийт эд мөрийн баримт",
  summaryInStorage: "Хадгалагдаж буй",
  summaryAnalysis: "Шинжилгээнд",
  summaryDisposal: "Устгал хүлээж буй",
  filterCategory: "Ангилал",
  filterStatus: "Хадгалалтын төлөв",
  filterCase: "Хэргийн дугаар",
  relatedCase: "Холбоотой хэрэг",
  registeredDate: "Бүртгэсэн огноо",
  registrant: "Бүртгэсэн",
  weight: "Жин / тоо хэмжээ",
  relationTitle: "Сүлжээний шинжилгээ",
  relationSub: "Хэрэгт холбогдох хүн, байгууллага, бодисын харилцааны зураглал",
  targetCase: "Сонгосон хэрэг",
  depth: "Хайлтын гүн",
  legend: "Тайлбар",
  nodeCase: "Хэрэг",
  nodePerson: "Хүн",
  nodeOrg: "Бүлэглэл",
  nodeSubstance: "Бодис",
  nodePlace: "Газар",
  edgeLabel: "Харилцаа",
  selectedNode: "Сонгосон зангилаа",
  connections: "Холболт",
  addRelation: "Харилцаа нэмэх",
  exportImage: "Зураг хадгалах",
  clickNodeHint: "Зангилаа дээр дарж дэлгэрэнгүй мэдээлэл харна уу",
  relSell: "Худалдсан",
  relSupply: "Нийлүүлсэн",
  relMember: "Гишүүн",
  relBoss: "Удирдагч",
  relBuy: "Худалдан авсан",
  relLocation: "Үйл ажиллагааны газар",
  relInvolved: "Холбогдсон",
  substanceTitle: "Бодисын мэдээллийн сан",
  substanceListSub: "Бодисын лавлах мэдээлэл болон спектрийн лавлагаа",
  casNo: "CAS дугаар",
  classification: "Ангилал",
  scheduleVal: "Сэтгэцэд нөлөөт бодис, I зэрэглэл",
  aliases: "Хар ярианы нэршил",
  refSpectra: "Лавлагаа спектр",
  fieldSamples: "Хээрийн шинжилгээний өгөгдөл",
  linkedCases: "Холбоотой хэрэг",
  spectrumViewer: "Спектр харагч",
  spectrumType: "Багажийн төрөл",
  overlayField: "Хээрийн өгөгдөл давхарлах",
  matchScore: "Тохирлын хувь",
  refCode: "Лавлагааны код",
  equipment: "Хэмжсэн багаж",
  measuredDate: "Хэмжсэн огноо",
  verifyStatus: "Баталгаажилт",
  verified: "Баталгаажсан",
  unverified: "Хүлээгдэж буй",
  wavenumber: "Раман шилжилт (см⁻¹)",
  intensity: "Харьцангуй эрчим",
  riskLevel: "Эрсдэлийн зэрэг",
  riskHigh: "Өндөр эрсдэлтэй",
  appearance: "Гадаад байдал",
  molFormula: "Молекулын томьёо",
  commonNames: "Зах зээлийн нэршил",
} as const;

export default mn;
